export default __webpack_public_path__ + "static/char-s-40-ja-f476b3f8959cf13f284f6999b4e1578a.png";